import AggregationFunctionConfiguration from "../../../lib/state/AggregationFunctionConfiguration";
import getAggregationFunctionsMap from "./getAggregationFunctionsMap";

function getAggregationFunctionSelectOptions(): AggregationFunctionConfiguration[] {
    return Object.values(getAggregationFunctionsMap()).sort((a, b) => a["order"] - b["order"]);
}

export default getAggregationFunctionSelectOptions;
